<template>
    <div>
        <el-button type="primary" @click="openDialog()" :loading="loading">新建</el-button>
    </div>
    <el-table :data="data" v-loading="loading" style="margin-top: 10px">
        <el-table-column label="头像" width="100" prop="resource">
            <template #default="scope">
                <el-image style="width: 90px" lazy
                          :src="`${$CDN_URL}/${scope.row.resource}`"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="活跃" width="100" prop="active">
            <template #default="scope">
                <el-switch v-model="scope.row.active" :disabled="loading" @change="update(scope.row)"></el-switch>
            </template>
        </el-table-column>
<!--        <el-table-column label="价格" width="100" prop="cost"></el-table-column>-->
        <el-table-column label="操作" width="200">
            <template #default="scope">
                <el-button type="success" circle icon="Top" :loading="loading" size="small"
                           :disabled="scope.$index===0" @click="moveUp(scope.$index)"></el-button>
                <el-button type="success" circle icon="Bottom" :loading="loading" size="small"
                           :disabled="scope.$index===data.length - 1" @click="moveDown(scope.$index)"></el-button>
                <el-button :loading="loading" size="small" @click="openDialog(scope.row)" icon="Edit"
                           circle></el-button>
                <el-button type="danger" :loading="loading" size="small" @click="remove(scope.row)" icon="Delete"
                           circle></el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog v-model="dialog_opened" :before-close="reset">
        <el-form :model="form" label-width="100px" ref="form">
            <el-form-item label="头像" prop="resource" :rules="[{required: true, message: '请上传头像'}]">
                <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleSuccess"
                           accept="image/*" :data="{prefix: 'avatar'}" :onProgress="handleProgress">
                    <img v-if="form.resource" :src="`${$CDN_URL}/${form.resource}`"
                         style="width: 200px">
                    <el-button size="small" v-else :loading="loading">上传</el-button>
                </el-upload>
            </el-form-item>
<!--            <el-form-item label="价格" prop="cost">-->
<!--                <el-input-number v-model="form.cost" :disabled="loading"></el-input-number>-->
<!--            </el-form-item>-->
        </el-form>
        <template #footer>
            <el-button type="primary" text :loading="loading" @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import {update} from "../libs/utils";
import axios from "ts-axios-new";
import {ElMessageBox} from 'element-plus'

export default {
    name: "Avatar",
    data() {
        return {
            loading: false, data: [], editing: null, dialog_opened: false,
            form: {
                resource: '',
                cost: 0,
                active: false,
            },
        }
    },
    methods: {
        init() {
            this.loading = true;
            axios.get(`/cms/v1/avatar`).then(res => {
                this.data = res.data.data.avatarList;
                this.loading = false;
            })
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                if (item) {
                    this.editing = item;
                    update(this.form, item);
                }
            })
        },
        reset() {
            this.$refs.form.resetFields();
            this.dialog_opened = this.loading = false;
            this.editing = null;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        axios.put(`/cms/v1/avatar/${this.editing.id}`, this.form).then(res => {
                            update(this.editing, res.data.data);
                            this.reset();
                        })
                    } else {
                        axios.post(`/cms/v1/avatar`, this.form).then(res => {
                            this.data.push(res.data.data);
                            this.reset();
                        })
                    }
                }
            })
        },
        update(row) {
            this.loading = true;
            axios.put(`/cms/v1/avatar/${row.id}`, row).then(res => {
                this.loading = false;
            })
        },
        remove(row) {
            ElMessageBox.confirm('确定要删除该项吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/avatar/${row.id}`).then(res => {
                    this.data.splice(this.data.indexOf(row), 1);
                    this.loading = false;
                })
            }).catch(_ => {
            })
        },
        handleSuccess(res) {
            this.loading = false;
            this.form.resource = res.data.name
        },
        handleProgress() {
            this.loading = true;
        },
        moveUp(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index - 1, 0, row[0]);
            this.resort();
        },
        moveDown(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index + 1, 0, row[0]);
            this.resort();
        },
        resort() {
            const sort = [];
            this.data.forEach(d => {
                sort.push(d.id);
            })
            axios.post(`/cms/v1/sort/avatar`, {sort}).then(_ => {
            })
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>

</style>